import { Text, TextArea, VStack } from "native-base";
import React, { useState } from "react";

import FormButton from "@/components/atoms/FormButton";
import Modal from "@/components/molecules/Modal";

type AddNotFoundItemsModalProps = {
  modalVisible: boolean;
  notFoundItemsText?: string;
  onClose: () => void;
  onSubmit: (notFoundItemsText: string) => void;
};

const AddNotFoundItemsModal = ({
  modalVisible,
  notFoundItemsText,
  onClose,
  onSubmit,
}: AddNotFoundItemsModalProps) => {
  const [text, setText] = useState(notFoundItemsText || "");

  const onPressClose = () => {
    setText("");
    onClose();
  };

  const onPressSubmit = () => {
    onSubmit(text);
    onClose();
  };

  return (
    <Modal
      isOpen={modalVisible}
      onClose={onPressClose}
      Header="O estabelecimento não tem o que você procura?"
      Body={
        <VStack>
          <Text pb="2">
            Se você não achou algum produto, escreva no campo abaixo de forma detalhada que o nosso
            separador vai tentar encontra-lo para você.
          </Text>
          <TextArea
            value={text}
            numberOfLines={5}
            onChangeText={(text) => setText(text)}
            placeholder="Escreva nome dos itens"
            mb="5"
            fontSize="md"
            autoCompleteType
          />
        </VStack>
      }
      Footer={
        <VStack w="full">
          <FormButton w="full" mb={22} onPress={onPressSubmit}>
            {notFoundItemsText ? "Alterar" : "Adicionar"}
          </FormButton>
          <FormButton
            w="full"
            mb={22}
            colorScheme="white"
            textColor="primary.700"
            onPress={onPressClose}>
            Cancelar
          </FormButton>
        </VStack>
      }
    />
  );
};

export default AddNotFoundItemsModal;
